import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function StatusCell(props) {
    return (
        <div className="status-cell">
            <div className="status-cell__label-wrapper">
                <span
                    style={{ backgroundColor: props.threshold.color }}
                    className="status-cell__indicator"
                    title={props.threshold.value}
                />
                <span className="status-cell__label">{props.label}</span>
            </div>
            <span className="status-cell__value">{props.value}</span>
        </div>
    );
}

StatusCell.propTypes = {
    label: PropTypes.string.isRequired,
    threshold: PropTypes.instanceOf(Object),
    value: PropTypes.string.isRequired
};

StatusCell.defaultProps = {
    threshold: {}
};

export default React.memo(StatusCell, (prevProps, nextProps) =>
    _.isEqual(prevProps.dataPoints, nextProps.dataPoints)
);
